import { AdditionalColors } from '@gc-bridge/theme/colors';
import { CookieOutlined } from '@mui/icons-material';
import { Button, styled, Typography } from '@mui/material';

export const StyledButton = styled(Button)(({ theme: { palette } }) => ({
  position: 'fixed',
  right: '40px',
  bottom: '30px',
  padding: '8px 16px',
  borderRadius: '32px',
  backgroundColor: AdditionalColors.Harmonies,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  boxShadow: `0px 1px 4px 0px rgba(0, 0, 0, 0.20)`,

  '&:hover': {
    backgroundColor: palette.primary.main,
    color: palette.primary.contrastText,
  },
}));

declare global {
  const Osano: {
    cm: {
      showDrawer: (id: string) => void;
    };
  };
}

export function ManageCookiesButton() {
  return (
    <StyledButton
      onClick={() => Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')}
    >
      <CookieOutlined sx={{ width: '20px', height: '20px' }} />
      <Typography
        fontSize="16px"
        textTransform="none"
        lineHeight="22px"
        letterSpacing="1px"
        color="inherit"
      >
        Manage Cookies
      </Typography>
    </StyledButton>
  );
}
